import http from '../../http';
import { SERVER_URL } from '../../config';

export const getStationData = () => http.get(`${SERVER_URL}/api-main/v1/station`, {});